import React from 'react';
import PropTypes from 'prop-types'

const style = {
    noData: {
        color: '#bcbcbc',
        textAlign: 'center',
        fontSize: 20,
        lineHeight: 25,
        width: '100%'
    }
}
export default class NoData extends React.Component {
    render() {
        return (
            <div style={style.noData}>
                暂无数据
            </div>
        );
    }
}
NoData.propTypes = {
    onAdd: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/uis/noData.js